import React from 'react';
import HintPopover from "../../../../gd-ui/hint-popover/hint-popover";
import {ItemIconClass} from "../../../../gd/const/item-icon/icon/item-icon-class";

type Props = {
    classes         : string
    value           : string
    onIconSelect    : callback
}

export default class IconItem extends React.Component<Props> {

    constructor(props: Props) {
        super(props);
    }

    onIconSelect = ()=> {
        this.props.onIconSelect(this.props.value)
    }


    render() {
        return (
            <div className={this.props.classes} onClick={this.onIconSelect}>
                <div className={"icon " + ItemIconClass[this.props.value]}></div>
                <HintPopover parent={this} hint={this.props.value} showDelay={500}/>
            </div>
        )
    }
}
